import { useEffect, useRef, useState, Dispatch, SetStateAction } from 'react'

import produce from 'immer'
import { Observable, EmptyError, merge, EMPTY, Subscription } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { isArray } from 'libraries/lodash'
import debug from 'front-end-core/core/debug'

const logError = (e: Error) => {
  (!(e instanceof EmptyError)) && debug.error(e)
  return EMPTY
}

const useBaseState = <T>(stateSource: Observable<T>, initialState:T, deps:any[] = []):{ baseState: T, setBaseState:Dispatch<SetStateAction<T>> } => {
  const [baseState, setBaseState] = useState<T>(initialState)
  const subscription = useRef<Subscription>(null)

  if (isArray(stateSource)) {
    stateSource = merge(...stateSource) as Observable<T>
  }

  useEffect(() => {
    return () => subscription.current && subscription.current.unsubscribe()
  }, [])

  useEffect(() => {
    if (stateSource instanceof Observable) {
      subscription.current = stateSource
      .pipe(
        catchError(logError)
      )
      .subscribe((s: T) => {
        setBaseState(prevState => produce(prevState, draft => {
          Object.entries(s).forEach(([key, value]) => {
            (draft as any)[key] = value // FIX ME
          })
        }))
      })
    }
  }, [...deps])

  return { baseState, setBaseState }
}

export default useBaseState
